<mat-form-field appearance="outline" floatLabel="always">
    <mat-label>SSN</mat-label>
    <input matInput [type]="ssnType$ | async" (input)="onSSNChange($event)" [(ngModel)]="_ssn" placeholder="000-00-0000"
        maxlength="11" [formControl]="ssnInputControl" class="form-control">

    <a matSuffix style="font-size:20px;" (click)="onToggleShowSSN()" title="Show / Hide SSN">
        <fa-icon icon='eye' *ngIf="!showSSN"></fa-icon>
        <fa-icon icon='eye-slash' *ngIf="showSSN"></fa-icon>
    </a>
</mat-form-field>